export default {
  onePersonVarA: {
    lang: {
      en: 'One place in the team, accommodation on the yacht',
      ru: 'Одно место в команде с проживанием на яхте',
      it: 'Un posto nella squadra, sistemazione sullo yacht',
    },
    places: 1,
  },
  onePersonVarB: {
    lang: {
      en: 'One place in the team, without accommodation on the yacht',
      ru: 'Одно место в команде без проживания на яхте',
      it: 'Un posto nella squadra, senza sistemazione sullo yacht',
    },
    places: 1,
  },
  onePersonVarC: {
    lang: {
      en: 'One place in the team, stern cabin',
      ru: 'Одно место в команде с проживанием в кормовой каюте для двух человек',
      it: 'Un posto nella squadra, cabina di poppa',
    },
    places: 1,
  },
  onePersonVarD: {
    lang: {
      en: 'One place in the team, bow cabin',
      ru: 'Одно место в команде с проживанием в носовой каюте для двух человек',
      it: 'Un posto nella squadra, cabina di prua',
    },
    places: 1,
  },
  twoPersonsVarA: {
    lang: {
      en: 'Stern cabin for up to 2 persons',
      ru: 'Кормовая каюта для двух человек',
      it: 'Cabina di poppa per un massimo di 2 persone',
    },
    places: 2,
  },
  twoPersonsVarB: {
    lang: {
      en: 'Cabin for up to 2 persons',
      ru: 'Каюта для двух человек',
      it: 'Cabina per un massimo di 2 persone',
    },
    places: 2,
  },
  morePersonsVarA: {
    lang: {
      en: 'Yacht with skipper for your team',
      ru: 'Яхта со шкипером под вашу команду',
      it: 'Yacht con skipper per la tua squadra',
    },
    places: null,
  },
  morePersonsVarB: {
    lang: {
      en: 'Bareboat for your team',
      ru: 'Яхта без шкипера под вашу команду',
      it: 'Scafo nudo per la tua squadra',
    },
    places: null,
  },
  morePersonsVarC: {
    lang: {
      en: 'Day Sailing with skipper',
      ru: 'Аренда яхты с капитаном на целый день',
      it: 'Day Sailing con skipper',
    },
    places: null,
  },
  morePersonsVarD: {
    lang: {
      en: 'Half-Day Sailing with skipper',
      ru: 'Аренда яхты с капитаном на полдня',
      it: 'Mezza giornata in barca a vela con skipper',
    },
    places: null,
  },
  morePersonsVarE: {
    lang: {
      en: 'Weekly yacht rental',
      ru: 'Аренда яхты со шкипером на 7 дней',
      it: 'Noleggio yacht settimanale',
    },
    places: null,
  },
  morePersonsVarF: {
    lang: {
      en: 'Participation in one stage',
      ru: 'Участие в одном этапе регаты',
      it: 'Partecipazione a una fase',
    },
    places: null,
  },
  morePersonsVarG: {
    lang: {
      en: 'Participation in all stages',
      ru: 'Участие во всех этапах регаты',
      it: 'Partecipazione a tutte le fasi',
    },
    places: null,
  },
};
